import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import home from '@/components/home'
import mainView from '@/components/mainView'
import sellerList from '@/components/sellerList'
import sellerOption from '@/components/sellerOption'
import creditSearch from '@/components/creditSearch'
import creditRules from '@/components/creditRules'
import creditLevel from '@/components/creditLevel'
import cardList from '@/components/cardList'
import cardClass from '@/components/cardClass'
import cardLabel from '@/components/cardLabel'
import orderSearch from '@/components/orderSearch'
import sysConfig from '@/components/sysConfig'
import companyManage from '@/components/companyManage'
import roleManage from '@/components/roleManage'
import accountManage from '@/components/accountManage'
import deptManage from '@/components/deptManage'
import cardCount from '@/components/cardCount'
import sellerCount from '@/components/sellerCount'
import orderCount from '@/components/orderCount'
import myAccount from '@/components/myAccount'
import wechatSetting from '@/components/wechatSetting'
import wechatMenu from '@/components/wechatMenu'
import agreementSetting from '@/components/agreementSetting'
import memberList from '@/components/supu/memberList'
import basicCard from '@/components/supu/basicCard'
import labelManage from '@/components/supu/labelManage'
import classifyManage from '@/components/supu/classifyManage'
import individualTimeCard from '@/components/supu/individualTimeCard'
import basicCardGive from '@/components/supu/basicCardGive'
import individualTimeCardGive from '@/components/supu/individualTimeCardGive'
import individualLesson from '@/components/supu/individualLesson'
import sourceBank from '@/components/sourceBank'
import sysNotice from '@/components/sysNotice'
import userOptionBack from '@/components/userOptionBack'
import wechatMessageTemplate from '@/components/wechatMessageTemplate'
import sysStyleSetting from '@/components/sysStyleSetting'

import banduRoutes  from  './bandu';
import readerRoutes from './reader';
import cardRoutes from './membership';
import channelRoutes from './channel';
import kanghujiaRoutes from './kanghujia';
Vue.use(Router)
const routes =[
  {
    path: '/',
    name: 'login',
    component: login
  },{
    path: '/index',
    name: 'homePage',
    component: home,
    children:[{
      path: '/',
      name: 'mainView',
      component: mainView
    },{
      path: '/sellerList',
      name: '用户管理',
      component: sellerList
    },{
      path: '/sellerOption',
      name: 'sellerOption',
      component: sellerOption
    },{
      path: '/creditSearch',
      name: '积分查询',
      component: creditSearch
    },{
      path: '/creditRules',
      name: '积分规则',
      component: creditRules
    },{
      path: '/creditLevel',
      name: '信用等级',
      component: creditLevel
    },{
      path: '/cardList',
      name: 'cardList',
      component: cardList
    },{
      path: '/cardClass',
      name: 'cardClass',
      component: cardClass
    },{
      path: '/cardLabel',
      name: 'cardLabel',
      component: cardLabel
    },{
      path: '/orderSearch',
      name: 'orderSearch',
      component: orderSearch
    },{
      path: '/sysConfig',
      name: 'sysConfig',
      component: sysConfig
    },{
      path: '/companyManage',
      name: '单位管理',
      component: companyManage
    },{
      path: '/roleManage',
      name: '角色管理',
      component: roleManage
    },{
      path: '/accountManage',
      name: '账号管理',
      component: accountManage
    },{
      path: '/deptManage',
      name: '商户管理',
      component: deptManage
    },{
      path: '/cardCount',
      name: 'cardCount',
      component: cardCount
    },{
      path: '/sellerCount',
      name: '用户统计',
      component: sellerCount
    },{
      path: '/orderCount',
      name: '订单统计',
      component: orderCount
    },{
      path: '/myAccount',
      name: '我的账号',
      component: myAccount
    },{
      path: '/wechatSetting',
      name: '微信设置',
      component: wechatSetting
    },{
      path: '/wechatMenu',
      name: '微信菜单',
      component: wechatMenu
    },{
      path: '/agreementSetting',
      name: '协议设置',
      component: agreementSetting
    },{
      path: '/memberList',
      name: '会员列表',
      component: memberList
    },{
      path: '/basicCard',
      name: 'basicCard',
      component: basicCard
    },{
      path: '/labelManage',
      name: 'labelManage',
      component: labelManage
    },{
      path: '/classifyManage',
      name: 'classifyManage',
      component: classifyManage
    },{
      path: '/individualTimeCard',
      name: 'individualTimeCard',
      component: individualTimeCard
    },{
      path: '/basicCardGive',
      name: 'basicCardGive',
      component: basicCardGive
    },{
      path: '/individualTimeCardGive',
      name: 'individualTimeCardGive',
      component: individualTimeCardGive
    },{
      path: '/individualLesson',
      name: 'individualLesson',
      component: individualLesson
    },{
      path: '/sourceBank',
      name: 'sourceBank',
      component: sourceBank
    },{
      path: '/gold-manager',
      name: '黄金管理',
      component: ()=>import('../components/goldRepo/manager.vue')
    },
    {
      path: '/gold-price',
      name: '系统金价',
      component: ()=>import('../components/goldRepo/price_list.vue')
    },
    {
      path: '/gold-repo-desc',
      name: '黄金回购说明',
      component: ()=>import('../components/goldRepo/repo_desc.vue')
    },{
      path: '/gold-repo-order',
      name: '黄金回购订单',
      component: ()=>import('../components/goldRepo/order.vue')
      //component: ()=>import('../components/qiniuSetting.vue')
      //component: ()=>import('../components/statistics/gold_order.vue')
    },{
      path: '/wechat-temp',
      name: '微信模板',
      component: ()=>import('../components/message/wechat_temp.vue')
    },{
      path: '/sta-gold-order',
      name: '黄金订单统计',
      component: ()=>import('../components/statistics/gold_order.vue')
    },{
      path: '/function-bind',
      name: '功能绑定',
      component: ()=>import('../components/function_bind.vue'),
      children:[
        {
        path: '',
        name: '公众号绑定',
        component: () => import('../components/bind/wechat_gzh.vue')
      },
        {
          path: '/wechat-gzh',
          name: '公众号绑定',
          component: () => import('../components/bind/wechat_gzh.vue')
        },
        {
          path: '/wechat-pay',
          name: '支付绑定',
          component: () => import('../components/bind/wechat_pay.vue')
        },
        {
          path: '/gold-data',
          name: '数据绑定',
          component: () => import('../components/bind/gold_data.vue')
        },
        {
          path: '/wechat-mini-pro',
          name: '小程序绑定',
          component: () => import('../components/bind/wechat_mini_pro.vue')
        }
      ]
    },{
      path: '/platform-bind',
      name: '平台绑定',
      component: ()=>import('../components/platform_bind.vue'),
      children:[
        {
        path: '/wechat-open-develop',
        name: '开放平台绑定',
        component: () => import('../components/bind/wechat_open_develop.vue')
      },
        {
          path: '/qiniu-setting',
          name: '七牛云设置',
          component: () => import('../components/qiniuSetting.vue')
        },
        {
          path: '/sms-setting',
          name: '短信平台',
          component: () => import('../components/smsSetting.vue')
        }
      ]
    },{
      path: '/image-material',
      name: '图片素材',
      component: ()=>import('../components/material/image_material.vue')
    },{
      path: '/sta-shop',
      name: '门店统计',
      component: ()=>import('../components/statistics/shop.vue')
    },{
      path: '/userOptionBack',
      name: 'userOptionBack',
      component: userOptionBack
    },{
      path: '/sysNotice',
      name: 'sysNotice',
      component: sysNotice
    },{
      path: '/wechatMessageTemplate',
      name: 'wechatMessageTemplate',
      component: wechatMessageTemplate
    },{
      path: '/sysStyleSetting',
      name: 'sysStyleSetting',
      component: sysStyleSetting
    },
    {
      path:'/index-setting',
      name:'首页配置',
      component: ()=>import('../components/official/index_setting.vue')
    },
    {
      path:'/news-manager',
      name:'新闻管理',
      component: ()=>import('../components/official/news_manage.vue')
    },
    {
      path:'/add-news',
      name:'发布新闻',
      component: ()=>import('../components/official/add_news.vue')
    },
    {
      path:'/edit-news',
      name:'编辑新闻',
      component: ()=>import('../components/official/add_news.vue')
    },
    {
      path:'/prize-manager',
      name:'获奖信息管理',
      component: ()=>import('../components/official/prize_manage.vue')
    },
    {
      path:'/add-prize',
      name:'新建获奖',
      component: ()=>import('../components/official/add_prize.vue')
    },
    {
      path:'/edit-prize',
      name:'编辑获奖',
      component: ()=>import('../components/official/add_prize.vue')
    },
    {
      path:'/note-manager',
      name:'通知公告',
      component: ()=>import('../components/official/note_manage.vue')
    },
    {
      path:'/add-note',
      name:'新建公告',
      component: ()=>import('../components/official/add_note.vue')
    },
    {
      path:'/edit-note',
      name:'编辑公告',
      component: ()=>import('../components/official/add_note.vue')
    },
    {
      path:'/case-manager',
      name:'案例列表',
      component: ()=>import('../components/official/case_manage.vue')
    },
    {
      path:'/add-case',
      name:'新建案例',
      component: ()=>import('../components/official/add_case.vue')
    },
    {
      path:'/edit-case',
      name:'编辑案例',
      component: ()=>import('../components/official/add_case.vue')
    },
    {
      path:'/about-manager',
      name:'关于公司',
      component: ()=>import('../components/official/about_manage.vue')
    }
  ]
  }
];
routes[1].children = routes[1].children.concat(banduRoutes,readerRoutes,cardRoutes,channelRoutes,kanghujiaRoutes);
export default new Router({
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js